"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var utilities_1 = require("../../../utilities/utilities");
var MessageBlock_1 = tslib_1.__importDefault(require("../../components/MessageBlock"));
var WidgetBackgroundEnd = function () {
    return react_1["default"].createElement(MessageBlock_1["default"], { color: "primary" }, utilities_1.__('Koniec pozadia'));
};
exports["default"] = react_1["default"].memo(WidgetBackgroundEnd);
